// Validador personalizado
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const deviceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const isValid = control.value && typeof control.value === 'object' && 'device' in control.value;

  return isValid ? null : { invalidDeviceObject: true };
};
